import { motion } from 'framer-motion';
import SectionHeading from '../../../components/ui/SectionHeading';
import Button from '../../../components/ui/Button';
import Card from '../../../components/ui/Card';
import maternelleImage from '../../../assets/images/Maternelle.webp';
import primaireImage from '../../../assets/images/Primaire.webp';
import collegeImage from '../../../assets/images/College1.webp';
import lyceeImage from '../../../assets/images/Lycee.webp';

interface Program {
  title: string;
  description: string;
  image: string;
  link: string;
}

const programs: Program[] = [
  {
    title: 'Maternelle',
    description: 'Pour les enfants de 3 à 5 ans, notre programme de maternelle stimule la curiosité naturelle et développe les compétences fondamentales.',
    image: maternelleImage,
    link: '/nos-cycles#maternelle'
  },
  {
    title: 'Primaire',
    description: 'Notre cycle primaire offre un apprentissage solide des fondamentaux avec un accent sur la maîtrise des langues et le développement personnel.',
    image: primaireImage,
    link: '/nos-cycles#primaire'
  },
  {
    title: 'Collège',
    description: 'Au collège, nous préparons les élèves à développer leur autonomie et leur esprit critique à travers un programme riche et varié.',
    image: collegeImage,
    link: '/nos-cycles#college'
  },
  {
    title: 'Lycée',
    description: "Notre lycée prépare les élèves à l'excellence académique et aux défis de l'enseignement supérieur et du monde professionnel.",
    image: lyceeImage,
    link: '/nos-cycles#lycee'
  },
];

const ProgramsSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Nos cycles d'enseignement"
          subtitle="De la maternelle au lycée"
          centered={true}
        />

        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {programs.map((program) => (
            <motion.div key={program.title} variants={itemVariants}>
              <Card className="h-full flex flex-col">
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <h3 className="absolute bottom-4 left-4 text-white text-xl font-bold">{program.title}</h3>
                </div>
                <div className="p-5 flex-grow">
                  <p className="text-gray-600 mb-4">{program.description}</p>
                  <div className="mt-auto">
                    <Button
                      to={program.link}
                      variant="ghost"
                      size="small"
                      className="mt-2"
                    >
                      En savoir plus
                    </Button>
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
        </motion.div>

        <div className="text-center mt-12">
          <Button to="/nos-cycles" variant="primary">
            Découvrir tous nos programmes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProgramsSection;
